import { useContext, useMemo } from 'react'

import { SettingsContext } from '../app/Settings'

export const useNumberFormat = (options?: Intl.NumberFormatOptions) => {
  const { locale } = useContext(SettingsContext)

  return useMemo(() => new Intl.NumberFormat(locale, options), [locale, options])
}
